module.exports = __webpack_public_path__ + "e6c20b1e388ed1ddf1657ab37db20bcc.svg";